import { useFpCampaignCartCalculate } from '@cart-services/hooks/useFpCampaignCartCalculate'
import { OrderDetail } from '@cart-ui/OrderDetail/OrderDetail'
import { Fade } from '@pets-ui/Fade/Fade'
import { useContextCampaignCart } from '../CartProvider/CampaignCartProvider'

export const CardOrderDetail = () => {
  const { currency, campaignId, campaignCode, countryCode } = useContextCampaignCart()
  const { destructuredData: calculateResult } = useFpCampaignCartCalculate(campaignId, campaignCode)

  const {
    discount_items,
    shipping_subtotal,
    total,
    subtotal,
    tax,
    total_without_addon_v2,
    addon_v2_total,
    addon_v2_total_before_discount,
  } = calculateResult || {}

  return (
    <Fade in>
      <OrderDetail
        discountItems={discount_items || []}
        shippingTotal={shipping_subtotal ?? 0}
        total={total ?? 0}
        subtotal={subtotal ?? 0}
        subtotalAfterDiscount={total_without_addon_v2 ?? 0}
        tax={tax ?? 0}
        currency={currency || 'TWD'}
        countryCode={countryCode}
        addonV2Total={addon_v2_total ?? 0}
        addonV2TotalBeforeDiscount={addon_v2_total_before_discount ?? 0}
      />
    </Fade>
  )
}
